import { ContentHubData } from "@app/types/ServerCustomContext";

import TechAwardsHighlightsContent from "./TechAwardsHighlightsContent";

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

export default function TechAwardsHighlights({ data }: Props) {
  const techAwardsContentLists = data?.storyPostData?.contentLists?.filter(
    (contentlist) => contentlist.targetKeys.includes("techawards"),
  );

  const contentListId = techAwardsContentLists?.[0]?.id;
  return (
    contentListId && (
      <TechAwardsHighlightsContent contentListId={contentListId} />
    )
  );
}
